module.exports = __webpack_public_path__ + "static/img/ios-img.32fcf84d.png";